import React, { useEffect, useState } from 'react';
import { Carousel, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { OnboardingAxios } from '../../API';
import authSlice from '../../store/auth/authSlice';

import './tour.css';

const Tour = (props) => {
    const dispatch = useDispatch();
    const [steps, setSteps] = useState([]);
    const userDetails = useSelector((state) => state.auth.loggedInUser);

    const TourSteps = {
        onboarding: ['../space/img/onboarding-slide-1.png'],
        journey: ['../space/img/learner-home-slide-1.jpg', '../space/img/learner-home-slide-2.jpg',  '../space/img/learner-home-slide-4.jpg'],
        dashboard: ['../space/img/learner-home-slide-1.jpg', '../space/img/learner-home-slide-2.jpg',  '../space/img/learner-home-slide-4.jpg'],
    coachDashbaord: ['../space/img/learner-home-slide-1.jpg', '../space/img/coach-home-slide-2.png', '../space/img/coach-home-slide-4.png' ],
    };

    useEffect(() => {
        let steps = TourSteps[props.tourItem];
        setSteps(steps);
    }, [props.startTour]);

    let element = document.getElementsByClassName("Help");
    element = element.length > 0 && element[0];
    if (element) {
        if (props.startTour) {
            element.style.zIndex = "1070";
        } else {
            setTimeout(function () { element.style.zIndex = "unset"; }, 3000);

        }
    }

    const CloseTour = () => {
        props.stopTour(false);
        if ((props.tourItem == 'dashboard' || props.tourItem == 'coachDashbaord') && !userDetails.tourCompleted) {
            // OnboardingAxios
            OnboardingAxios.get('OfferingUsers/settourcompleted/' + userDetails.offeringUserId)
                .then(() => {
                    dispatch(authSlice.actions.setTourCompleted());
                    console.log("Tour completed");
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    return <>
        <Modal
            style={{ zIndex: "223564" }}
            show={props.startTour}
            onHide={CloseTour}
            dialogClassName="tour modal-90w"
            aria-labelledby="tour-modal"
            centered
            backdropClassName="clip-help"
        >
            <Modal.Body>
                <div className="cdx-modal-close" style={{ zIndex: 10 }} onClick={CloseTour} />
                <Carousel fade
                    indicators={false}
                    prevLabel=""
                    nextLabel=""
                    prevIcon={steps.length > 1 && <span aria-hidden="true" className="carousel-control-prev-icon" />}
                    nextIcon={steps.length > 1 && <span aria-hidden="true" className="carousel-control-next-icon" />}
                    className='tour-slide'
                >
                    {steps.map((item, index) => {
                        return <Carousel.Item key={"tour-slide-" + index}>
                            <img
                                className="tour-image d-block"
                                src={item}
                                alt="First slide"
                            />
                        </Carousel.Item>;
                    })}

                </Carousel>

            </Modal.Body>
        </Modal>
    </>;
};

export default Tour;